// extracted by mini-css-extract-plugin
export default {"container":"PJzyI","postMainActionContainer":"mC1aU","icon":"_2Z9BZ","wrapper":"_2eHhI","postPageRevamp":"_8-2mu","postMainActionWrapper":"_59RTt"};